var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuntosInteres(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 341.8 500",
    style: {
      enableBackground: "new 0 0 341.8 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC8C15;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000021114093344651665790000016518315863312094630_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271,389.4c-12.7-4.4-25.7-7.7-39-9.9c9.1-10.7,18.8-22.6,28.6-35.3c53.9-70,81.2-128.3,81.2-173.3 C341.8,76.7,265.1,0,170.9,0S0,76.7,0,170.9c0,45.2,27.3,103.6,81.2,173.6c9.7,12.6,19.4,24.4,28.5,35.1 c-13.2,2.2-26.2,5.5-38.9,9.9c-40.6,14.5-49.2,34-49.2,47.8s8.5,33.3,49.2,47.8c27,9.6,62.5,15,100.1,15s73.1-5.3,100.1-15 c40.6-14.5,49.2-34,49.2-47.8S311.6,403.9,271,389.4z M29.3,170.9c0-78.1,63.5-141.6,141.6-141.6s141.6,63.5,141.6,141.6 c0,37.8-25.9,91.5-74.9,155.2c-20.9,26.9-43.1,52.8-66.7,77.3c-23.5-24.4-45.7-50-66.5-76.8C55.3,262.8,29.3,209,29.3,170.9z  M261.2,457.5c-23.9,8.5-56,13.2-90.3,13.2s-66.4-4.7-90.3-13.2C59,449.7,50.9,441,50.9,437.2S59,424.8,80.6,417 c14.8-5.3,32.7-9.1,52.3-11.2c15.9,17.4,26.9,28.1,27.8,29l10.2,10l10.2-10c0.9-0.8,11.8-11.6,27.7-29 c19.6,2.1,37.6,5.9,52.4,11.2c21.6,7.7,29.7,16.5,29.7,20.2S282.8,449.7,261.2,457.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.2,142.3c-2-5.1-7.8-7.7-12.9-5.7c-4.7,1.8-7.3,6.9-6.1,11.8c10.5,32.6-7.4,67.5-40,78 c-32.6,10.5-67.5-7.4-78-40s7.4-67.5,40-78c11.6-3.7,24-4,35.7-0.7c5.3,1.5,10.8-1.6,12.3-7c1.5-5.3-1.6-10.8-7-12.3l0,0 c-43.6-12.2-88.8,13.3-101,56.9s13.3,88.8,56.9,101s88.8-13.3,101-56.9C254.5,174.1,254.2,157.6,249.2,142.3L249.2,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.2,109.6L228.2,109.6c-4.2-3.8-10.5-3.4-14.2,0.7c-3.4,3.8-3.4,9.5,0,13.3l0.1,0.1 c4,3.8,10.3,3.7,14.1-0.2C232,119.6,232,113.5,228.2,109.6L228.2,109.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosInteres);
export default __webpack_public_path__ + "static/media/Puntos-interes.a764b618d871c2356653898afc32af6c.svg";
export { ForwardRef as ReactComponent };